import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<Actions.UPDATE_PASSWORD_ASYNC, Actions.UPDATE_PASSWORD_SUCCESS, Actions.UPDATE_PASSWORD_FAIL>,
): State => {
  switch (action.type) {
    case Actions.UPDATE_PASSWORD_ASYNC:
    case Actions.UPDATE_PASSWORD_SUCCESS:
    case Actions.UPDATE_PASSWORD_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    default:
      return state
  }
}
